// extracted by mini-css-extract-plugin
module.exports = {"triptic":"Triptic_triptic__2vddo","inner":"Triptic_inner__1LX9s"};